var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spare-part-kit-item" }, [
    _c("div", { staticClass: "spare-part-kit-item__inner" }, [
      _c("h3", { staticClass: "spare-part-kit-item__number" }, [
        _vm._v(_vm._s(_vm.sparePartKit.ItemNumber))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "spare-part-kit-item__description" }, [
        _vm._v(_vm._s(_vm.sparePartKit.Description))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "spare-part-kit-item__description" }, [
        _vm._v(_vm._s(_vm.sparePartKit.ExtendedDescription))
      ]),
      _vm._v(" "),
      _vm.sparePartKit.HasPdfUrl
        ? _c(
            "a",
            {
              staticClass: "spare-part-kit-item__link",
              attrs: { href: _vm.sparePartKit.PdfUrl, target: "_blank" }
            },
            [_vm._v(_vm._s(_vm.buttonText))]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77d3d885", { render: render, staticRenderFns: staticRenderFns })
  }
}